import { graphql } from 'react-relay';

export const CreateWhiteboardMutation = graphql`
	mutation WhiteboardExtensionCreateWhiteboardMutation(
		$createdInContentId: ID!
		$spaceKey: String
	) {
		createContentInline(
			input: { createdInContentId: $createdInContentId, spaceKey: $spaceKey, type: "whiteboard" }
		) {
			id
		}
	}
`;
